import { render, staticRenderFns } from "./FooterContactUs.vue?vue&type=template&id=6daefa1d&scoped=true&"
import script from "./FooterContactUs.vue?vue&type=script&lang=js&"
export * from "./FooterContactUs.vue?vue&type=script&lang=js&"
import style0 from "./FooterContactUs.vue?vue&type=style&index=0&id=6daefa1d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daefa1d",
  null
  
)

export default component.exports